import React from "react"
import { AppLayout } from "@kit/design/app-layout"
import { useMediaBreakpoint } from "@kit/design/use-media-breakpoint"
import { AppNavigation } from "app/navigation/app-navigation"
import { LayoutBanners } from "./layout-banners"

export function VerticalNavLayout({ layoutConfig, children }) {
  const isMobile = !useMediaBreakpoint("md")
  return (
    <AppLayout>
      <AppNavigation mobile={isMobile} />
      <AppLayout.Content mobile={isMobile}>
        <LayoutBanners layoutConfig={layoutConfig} />
        {children}
      </AppLayout.Content>
    </AppLayout>
  )
}
